export default "__VITE_ASSET__ho2mt1qr__"